/**
 * Note: The below data is originated from Adyen's payment card types
 *
 * For reference, all the possible values can be found at https://docs.adyen.com/development-resources/paymentmethodvariant
 */

import { PaymentCardTypes } from '../enums/payments';

export const VISA_DEBIT_TYPES = [
  'visacommercialdebit',
  'visacommercialpremiumdebit',
  'visacommercialsuperpremiumdebit',
  'visacorporatedebit',
  'visadebit',
  'visafleetdebit',
  'visapremiumdebit',
  'visapurchasingdebit',
  'visastandarddebit',
  'visasuperpremiumdebit',
];
export const VISA_CREDIT_TYPES = [
  'visacommercialcredit',
  'visacommercialpremiumcredit',
  'visacommercialsuperpremiumcredit',
  'visacorporatecredit',
  'visacredit',
  'visafleetcredit',
  'visapremiumcredit',
  'visapurchasingcredit',
  'visastandardcredit',
  'visasuperpremiumcredit',
];
export const MASTERCARD_DEBIT_TYPES = [
  'mccommercialdebit',
  'mccommercialpremiumdebit',
  'mccorporatedebit',
  'mcdebit',
  'mcfleetdebit',
  'mcpremiumdebit',
  'mcpurchasingdebit',
  'mcstandarddebit',
  'mcsuperpremiumdebit',
];
export const MASTERCARD_CREDIT_TYPES = [
  'mccommercialcredit',
  'mccommercialpremiumcredit',
  'mccorporatecredit',
  'mccredit',
  'mcfleetcredit',
  'mcpremiumcredit',
  'mcpurchasingcredit',
  'mcstandardcredit',
  'mcsuperpremiumcredit',
];
export const VISA_TYPES = [
  'visa',
  'visacorporate',
  'visagold',
  'visahipotecario',
  'visaplatinum',
  'visaprepaidanonymous',
  'visaproprietary',
  'visapurchasing',
  'visasaraivacard',
  'visasignature',
];
export const MASTERCARD_TYPES = [
  'mc',
  'mccorporate',
  'mcpro',
  'mcprepaidanonymous',
];
export const AMEX_TYPES = ['amex'];
export const EFTPOS_SAVING_TYPES = ['eftpos_australia_sav'];
export const EFTPOS_CHEQUE_TYPES = ['eftpos_australia_chq'];

export const PAYMENT_CARD_TYPES_MAPPING: Record<string, PaymentCardTypes> = {
  ...VISA_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.VISA,
    }),
    {},
  ),
  ...MASTERCARD_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.MASTERCARD,
    }),
    {},
  ),
  ...VISA_DEBIT_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.VISA_DEBIT,
    }),
    {},
  ),
  ...VISA_CREDIT_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.VISA_CREDIT,
    }),
    {},
  ),
  ...MASTERCARD_DEBIT_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.MASTERCARD_DEBIT,
    }),
    {},
  ),
  ...MASTERCARD_CREDIT_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.MASTERCARD_CREDIT,
    }),
    {},
  ),
  ...AMEX_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.AMERICAN_EXPRESS,
    }),
    {},
  ),
  ...EFTPOS_CHEQUE_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.EFTPOS_CHQ,
    }),
    {},
  ),
  ...EFTPOS_SAVING_TYPES.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: PaymentCardTypes.EFTPOS_SAVING,
    }),
    {},
  ),
};
